import { BMPrimitives, BMText, useBMTheme } from "@traveloka/district-bloom";
import { FlatList, StyleSheet } from "react-native";
import BMView from "../../../components/View/BMView";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { useRecentlyViewedHotels } from "../../../providers/api/RecentlyViewedHotelsContext";
import HotelCard from "./HotelCard";

export default function RecentlyViewedHotel() {
  const bmTheme = useBMTheme();
  const hotels = useRecentlyViewedHotels();
  const { CorporateHotelRecentlySearch } = useMobileContentResource();

  return (
    <BMView
      style={[
        styles.container,
        { backgroundColor: bmTheme.BMComponents.BMStyleSurfaceBgcolor },
      ]}
    >
      <BMText
        style={styles.title}
        ink="BMStyleTextInkPrimary"
        variant="titleSmall"
      >
        {CorporateHotelRecentlySearch.recentlyViewedHotelText}
      </BMText>
      <FlatList
        horizontal
        data={hotels?.recentlySearchedHotels}
        renderItem={({ item }) => <HotelCard {...item} />}
        style={styles.hotelList}
        contentContainerStyle={styles.hotelItem}
        showsHorizontalScrollIndicator={false}
      />
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: BMPrimitives.BMSize.md,
  },
  title: {
    paddingHorizontal: BMPrimitives.BMSize.lg,
  },
  hotelList: {
    paddingRight: BMPrimitives.BMSize.md,
  },
  hotelItem: {
    gap: BMPrimitives.BMSize.md,
    paddingVertical: BMPrimitives.BMSize.lg,
    paddingLeft: BMPrimitives.BMSize.md,
  },
});
